import Avatar from '@mui/material/Avatar';

import { brand } from '../theme';

export default function MintAvatar({
  src,
  symbol,
  size,
}: {
  src?: string | null;
  symbol: string;
  size: number;
}) {
  const letter = (symbol.trim()[0] ?? '?').toUpperCase();

  return (
    <Avatar
      src={src || undefined}
      alt={symbol}
      sx={{
        width: size,
        height: size,
        flex: 'none',
        fontSize: size * 0.4,
        fontWeight: 800,
        backgroundColor: '#fff',
        color: brand.goldDeep,
        border: `1px solid ${brand.hairline}`,
        borderRadius: '50%',
        overflow: 'hidden',
        '& .MuiAvatar-img': {
          objectFit: 'contain',
          padding: '12%',
          boxSizing: 'border-box',
        },
      }}
    >
      {letter}
    </Avatar>
  );
}
